<template>
  <SideBar title="Publicar Servicio">
    <div class="bg-white overflow-hidden shadow rounded-lg">
      <div class="px-4 py-5 sm:p-6">
        <div class="sm:flex">
        <div class="sm:w-1/2 sm:pr-2">
          <div>
            <label
              for="input_title"
              class="block text-sm font-medium leading-5 text-gray-700"
            >
              Título
            </label>
            <div class="mt-1 rounded-md shadow-sm">
              <input
                id="input_title"
                v-model="title"
                class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
              />
            </div>
            <small v-if="error_title" class="text-red-600">{{
              error_title
            }}</small>
          </div>

          <div class="mt-6">
            <label
              for="input_description"
              class="block text-sm font-medium leading-5 text-gray-700"
            >
              Descripción
            </label>
            <div class="mt-1 rounded-md shadow-sm">
              <textarea
                id="input_description"
                v-model="description"
                rows="6"
                class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
              ></textarea>
            </div>
            <small v-if="error_description" class="text-red-600">{{
              error_description
            }}</small>
          </div>

          <div class="mt-6">
            <label
              for="select_category"
              class="block text-sm font-medium leading-5 text-gray-700"
            >
              Categoría
            </label>
            <div class="mt-1 rounded-md shadow-sm">
              <select
                id="select_category"
                class="form-select block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
              >
                <option disabled="">Seleccionar</option>
                <option value="Gastifero">Gasfitería</option>
                <option value="Electricista">Electricidad</option>
                <option value="Carpintero">Carpintería</option>
                <option value="Cerrajero">Cerrajería</option>
              </select>
            </div>
          </div>
        </div>
        <div class="sm:w-1/2 sm:pl-2">
          <div class="grid grid-cols-1 row-gap-6 col-gap-4 sm:grid-cols-6">
            <div class="sm:col-span-2">
              <label
                for="select_department"
                class="block text-sm font-medium leading-5 text-gray-700"
              >
                Departamento
              </label>
              <div class="mt-1 rounded-md shadow-sm">
                <select
                  id="select_department"
                  v-model="department"
                  class="form-select block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                >
                  <option disabled="" value="">Seleccionar</option>
                  <option>Lima</option>
                  <!--option value="01">Amazonas</option
                  ><option value="02">Áncash</option
                  ><option value="03">Apurímac</option
                  ><option value="04">Arequipa</option
                  ><option value="05">Ayacucho</option
                  ><option value="06">Cajamarca</option
                  ><option value="07">Callao</option
                  ><option value="08">Cusco</option
                  ><option value="09">Huancavelica</option
                  ><option value="10">Huánuco</option
                  ><option value="11">Ica</option
                  ><option value="12">Junín</option
                  ><option value="13">La Libertad</option
                  ><option value="14">Lambayeque</option
                  ><option value="15">Lima</option
                  ><option value="16">Loreto</option
                  ><option value="17">Madre de Dios</option
                  ><option value="18">Moquegua</option
                  ><option value="19">Pasco</option
                  ><option value="20">Piura</option
                  ><option value="21">Puno</option
                  ><option value="22">San Martín</option
                  ><option value="23">Tacna</option
                  ><option value="24">Tumbes</option
                  ><option value="25">Ucayali</option-->
                </select>
              </div>
              <small v-if="error_department" class="text-red-600">{{
                error_department
              }}</small>
            </div>

            <div class="sm:col-span-2">
              <label
                for="select_province"
                class="block text-sm font-medium leading-5 text-gray-700"
              >
                Provincia
              </label>
              <div class="mt-1 rounded-md shadow-sm">
                <select
                  id="select_province"
                  v-model="province"
                  class="form-select block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                >
                  <option disabled="" value="">Seleccionar</option>
                  <option value="01">Lima</option>
                </select>
              </div>
              <small v-if="error_province" class="text-red-600">{{
                error_province
              }}</small>
            </div>

            <div class="sm:col-span-2">
              <label
                for="select_district"
                class="block text-sm font-medium leading-5 text-gray-700"
              >
                Distrito
              </label>
              <div class="mt-1 rounded-md shadow-sm">
                <select
                  id="select_district"
                  v-model="district"
                  class="form-select block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                >
                  <option selected="" disabled="" value="">Seleccionar</option>
                  <option>Lima</option>
                </select>
              </div>
              <small v-if="error_district" class="text-red-600">{{
                error_district
              }}</small>
            </div>

            <div class="sm:col-span-3">
              <label
                for="input_min_price"
                class="block text-sm font-medium leading-5 text-gray-700"
              >
                Menor Precio
              </label>
              <div class="mt-1 rounded-md shadow-sm">
                <input
                  id="input_min_price"
                  type='number'
                  v-model="min_price"
                  class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
              </div>
              <small v-if="error_min_price" class="text-red-600">{{
                error_min_price
              }}</small>
            </div>

            <div class="sm:col-span-3">
              <label
                for="input_max_price"
                class="block text-sm font-medium leading-5 text-gray-700"
              >
                Mayor Precio
              </label>
              <div class="mt-1 rounded-md shadow-sm">
                <input
                  id="input_max_price"
                  type='number'
                  v-model="max_price"
                  class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
              </div>
              <small v-if="error_max_price" class="text-red-600">{{
                error_max_price
              }}</small>
            </div>

            <div class="sm:col-span-6">
              <label for="cover_photo" class="block text-sm leading-5 font-medium text-gray-700">
                Imagen
              </label>
              <div class="mt-2 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                <div class="text-center">
                  <svg class="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48">
                    <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  <p class="mt-1 text-sm text-gray-600">
                    <button type="button" class="font-medium text-teal-600 hover:text-teal-500 focus:outline-none focus:underline transition duration-150 ease-in-out">
                      Agregar fotos
                    </button>
                  </p>
                  <p class="mt-1 text-xs text-gray-500">
                    PNG, JPG hasta 10MB
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
        <div class="mt-8 border-t border-gray-200 pt-5">
          <div class="flex justify-end">
            <span class="inline-flex rounded-md shadow-sm">
              <button
                type="button"
                class="py-2 px-4 border border-gray-300 rounded-md text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800 transition duration-150 ease-in-out"
              >
                Cancelar
              </button>
            </span>
            <span class="ml-3 inline-flex rounded-md shadow-sm">
              <MyButton
                content="Siguiente"
                color="primary"
                @onClick="submitForm()"
                :isLoading="buttonLoading"
              ></MyButton>
            </span>
          </div>
        </div>
      </div>
    </div>
  </SideBar>
</template>

<script>
import api from "../../api";

import SideBar from "../../components/SideBar";
import MyButton from "../../components/MyButton.vue";

export default {
  name: "CreateService",
  components: {
    SideBar,
    MyButton
  },
  data() {
    return {
      hasError: false,
      buttonLoading: false,
      title: '',
      description: '',
      department: '',
      province: '',
      district: '',
      min_price: '',
      max_price: '',

      error_title: '',
      error_description: '',
      error_department: '',
      error_province: '',
      error_district: '',
      error_min_price: '',
      error_max_price: '',
    }
  },
  methods: {
    async submitForm() {
      this.validateSubmit();
      if (this.hasError) return;
      this.buttonLoading = true;
      let response = await api.post(`/worker/service/create`, {
        title: this.title,
        description: this.description,
        department: this.department,
        province: this.province,
        district: this.district,
        min_price: this.min_price,
        max_price: this.max_price,
      })
      if (!response.ok) {
        this.buttonLoading = false;
        return this.$toast.open({
          message: response.error || 'Ocurrió un error, vuelva a intentarlo',
          type: "error",
          duration: 8000,
          dismissible: true
        });
      }
      this.$toast.open({
        message: 'Servicio creado',
        type: "success",
        duration: 8000,
        dismissible: true
      });
    },
    validateSubmit() {
      this.hasError = false;
      if (this.title == "") {
        this.hasError = true;
        this.error_title = "Campo obligatorio";
      } else if (this.title.length > 50) {
        this.hasError = true;
        this.error_title = "Título demasiado largo";
      } else this.error_title = "";
      if (this.description == "") {
        this.hasError = true;
        this.error_description = "Campo obligatorio";
      } else if (this.description.length > 1200) {
        this.hasError = true;
        this.error_description = "Descripción demasiado larga";
      } else this.error_description = "";
      if (this.department == "") {
        this.hasError = true;
        this.error_department = "Campo obligatorio";
      } else this.error_department = "";
      if (this.province == "") {
        this.hasError = true;
        this.error_province = "Campo obligatorio";
      } else this.error_province = "";
      if (this.district == "") {
        this.hasError = true;
        this.error_district = "Campo obligatorio";
      } else this.error_district = "";
      if (this.min_price == "") {
        this.hasError = true;
        this.error_min_price = "Campo obligatorio";
      } else if (this.min_price < 70) {
        this.hasError = true;
        this.error_min_price = "Precio demasiado bajo para nuestra política";
      } else this.error_min_price = "";
      if (this.max_price == "") {
        this.hasError = true;
        this.error_max_price = "Campo obligatorio";
      } else if (this.max_price < 71) {
        this.hasError = true;
        this.error_max_price = "Precio demasiado bajo para nuestra política";
      } else this.error_max_price = "";
    }
  }
}
</script>